import { ApolloError } from 'apollo-client';
import { KeyedMutator } from 'swr';

import useTypedSWR from 'src/components/general/useTypedSWR';
import {
  Staff_RecommendationType as RecommendationType,
  PharmaciesQuery,
  Staff_Pharmacy as PharmacyType,
} from 'src/generated/gql/graphql';
import { PHARMACIES_QUERY } from 'src/pharmacyRecommendations/usePharmacyRecommendations.gql';

export interface PaginatedPharmacies {
  pharmacies: PharmacyType[];
  totalCount: number;
  pageCount: number;
  currentPage: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export function usePharmacyRecommendations(
  city: string | null,
  name: string | null,
  recommendation: RecommendationType | null,
  state: string | null,
  zip: string | null,
  page = 1,
  pageSize = 100,
): {
  paginatedPharmacies: PaginatedPharmacies;
  error?: ApolloError;
  mutate: KeyedMutator<PharmaciesQuery>;
  loading: boolean;
} {
  const { data, error, mutate, isValidating } = useTypedSWR(
    city || name || recommendation || state || zip
      ? [PHARMACIES_QUERY, { city, name, recommendation, state, zip, page, pageSize }]
      : null,
    { revalidateOnFocus: false },
  );

  if (!data?.staff_pharmacies) {
    return {
      paginatedPharmacies: {
        pharmacies: [],
        totalCount: 0,
        pageCount: 0,
        currentPage: page,
        hasNextPage: false,
        hasPreviousPage: false,
      },
      error,
      mutate,
      loading: isValidating,
    };
  }

  return {
    paginatedPharmacies: data.staff_pharmacies,
    error,
    mutate,
    loading: isValidating,
  };
}
